
import { Component, Prop, Vue } from "vue-property-decorator";
import Wrapper from "../forms/wrapper.vue";
import VSelect from "@components/plugins/vue-select.vue";

@Component({
  name: "ci-ais-select",
  components: {
    VSelect,
    "ci-fe-wrapper": Wrapper,
  },
})
export default class extends Vue {
  @Prop({ required: true }) public attribute!: string;
  @Prop({ default: "" }) public label!: string;
  @Prop({ default: true }) public showCount!: boolean;
  @Prop({ default: "value" }) public valueKey!: string;
  @Prop({ default: 10 }) public limit!: number;
  @Prop() public transformItems!: any[];

  public internalValue: Nullable<ExplicitAny> = null;

  public initialize(items: ExplicitAny[]): ExplicitAny {
    /*
     * Set the value in the next tick or our input wrapper will display the label over the value
     * When setting it in the next tick it will be empty for a moment before showing the value.
     */
    this.$nextTick(() => (this.internalValue = items.find((item) => item.isRefined) || ""));
    return this.internalValue;
  }

  public mapToValues(option: Indexable<string>): string {
    return option[this.valueKey];
  }

  public handleInput(value: string, refine: (v: string) => void): void {
    this.internalValue = value;
    refine(value);
  }
}
